import React from 'react';
import { MapPin, Wrench, Truck } from 'lucide-react';

const QuiSommesNous = () => {
  return (
    <section id="qui-sommes-nous" className="py-24 bg-gradient-to-br from-slate-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#FF6600] font-semibold text-sm uppercase tracking-wider">À propos</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-3 mb-4">
            Qui sommes-nous ?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Une petite entreprise réactive au service de vos projets logistiques
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-3 gap-8">
          
          {/* Card 1: Localisation */}
          <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow p-8 border-t-4 border-[#FF6600]">
            <div className="flex items-center justify-center w-16 h-16 bg-[#FF6600]/10 rounded-full mb-6 mx-auto">
              <MapPin className="w-8 h-8 text-[#FF6600]" />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center">
              Notre Localisation
            </h3>
            <p className="text-gray-600 text-center mb-6">
              Petite entreprise réactive basée à <strong>Nevers (58)</strong> dans la Nièvre
            </p>
            
            {/* Carte de France */}
            <div className="bg-slate-50 rounded-xl p-4 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_tranship-solutions/artifacts/y7qgan3b_IMG_4993.png"
                alt="Carte de France - Nièvre en rouge"
                className="w-48 h-48 object-contain mx-auto"
              />
            </div>
            
            <div className="text-center">
              <span className="inline-block px-4 py-2 bg-[#FF6600]/10 text-[#FF6600] rounded-full text-sm font-semibold">
                📍 Nevers (58)
              </span>
            </div>
          </div>

          {/* Card 2: Fabrication */}
          <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow p-8 border-t-4 border-blue-500">
            <div className="flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6 mx-auto">
              <Wrench className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center">
              Fabrication Locale
            </h3>
            <p className="text-gray-600 text-center mb-6">
              Nos équipements de quai sont fabriqués par notre atelier partenaire situé dans la Nièvre (58)
            </p>
            
            {/* Image atelier */}
            <div className="rounded-xl overflow-hidden mb-4 shadow-md">
              <img 
                src="https://images.unsplash.com/photo-1745448797900-35d08e85e9db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHx3ZWxkaW5nJTIwd29ya3Nob3AlMjBpbmR1c3RyaWFsJTIwZmFicmljYXRpb258ZW58MHx8fHwxNzc0NDc4NTQzfDA&ixlib=rb-4.1.0&q=85"
                alt="Atelier de fabrication partenaire - Nevers"
                className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            
            <div className="text-center">
              <span className="inline-block px-4 py-2 bg-blue-50 text-blue-700 rounded-full text-sm font-semibold">
                🔧 Made in France
              </span>
            </div>
          </div>

          {/* Card 3: Déplacement */}
          <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow p-8 border-t-4 border-green-500">
            <div className="flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6 mx-auto">
              <Truck className="w-8 h-8 text-green-600" />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center">
              Intervention Nationale
            </h3>
            <p className="text-gray-600 text-center mb-6">
              Notre équipe de pose se déplace <strong>partout en France</strong> sans exception
            </p>
            
            {/* Image camion */}
            <div className="rounded-xl overflow-hidden mb-4 shadow-md">
              <img 
                src="https://customer-assets.emergentagent.com/job_tranship-solutions/artifacts/04dxe4yl_1FC8B289-ACEA-4804-9C55-E8518A0C8D6A.png"
                alt="Renault Trafic Orion Industrie"
                className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            
            <div className="text-center">
              <span className="inline-block px-4 py-2 bg-green-50 text-green-700 rounded-full text-sm font-semibold">
                🚚 Toute la France
              </span>
            </div>
          </div>
          
        </div>

        {/* Bottom Banner */}
        <div className="mt-16 bg-gradient-to-r from-[#FF6600] to-[#E65A00] rounded-2xl p-8 text-center shadow-xl">
          <p className="text-white text-xl md:text-2xl font-bold mb-2">
            ✨ Réactivité • Proximité • Savoir-faire français
          </p>
          <p className="text-white/90 text-lg">
            Une entreprise à taille humaine pour des solutions sur mesure
          </p>
        </div>
      </div>
    </section>
  );
};

export default QuiSommesNous;
